import TableTextFilter from './components/TableTextFilter';
import TableSelectFilter from './components/TableSelectFilter';
import { Flex, Text, Button, Tooltip } from '@chakra-ui/react';
import { FiSend } from 'react-icons/fi';

export const subscriptionColumns = (onOpen, setSelectedIndex) => [
  {
    Header: 'Location',
    accessor: 'location',
    Filter: TableTextFilter,
  },
  {
    Header: 'Service',
    accessor: 'service',
    Filter: TableSelectFilter,
  },
  {
    Header: 'Rate',
    accessor: 'rate',
    isNumeric: true,
  },
  {
    Header: 'Frequency',
    accessor: 'frequency',
  },
  {
    Header: 'Next Bill Date',
    accessor: 'billDate',
  },
  {
    Header: 'Billing Method',
    accessor: 'billingMethod',
    Cell: props => (
      <Tooltip
        closeOnMouseDown
        hasArrow
        label="Update billing method"
        placement="top"
        openDelay={2000}
      >
        <Flex align="center">
          <Text>{props.value}</Text>
          <Button
            size="xs"
            ml={2}
            onClick={() => {
              setSelectedIndex(props.row.index);
              onOpen();
            }}
          >
            Change
          </Button>
        </Flex>
      </Tooltip>
    ),
  },
];

export const billingsColumns = (onOpen, setSelectedInvoiceRow) => [
  {
    Header: 'Date/Time',
    accessor: 'dateTime',
    sortType: (rowA, rowB, id, desc) => {
      return (
        new Date(rowA.original.createdOn) - new Date(rowB.original.createdOn)
      );
    },
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    isNumeric: true,
    disableSortBy: true,
  },
  {
    Header: 'Description',
    accessor: 'description',
    // Filter: TableSelectFilter,
    disableSortBy: true,
    Cell: props =>
      props.value.length < 100 ? (
        <Text>{props.value}</Text>
      ) : (
        <Tooltip
          closeOnMouseDown
          hasArrow
          label={props.value}
          placement="top"
          openDelay={1000}
        >
          <Text>{props.value.substring(0, 100)}...</Text>
        </Tooltip>
      ),
  },
  {
    Header: 'Location(if applicable)',
    accessor: 'location',
    disableSortBy: true,
    // Filter: TableTextFilter,
  },
  {
    Header: 'Result',
    accessor: 'result',
    disableSortBy: true,
    Cell: props =>
      props.value === 'Approved' ? (
        <>
          <Text fontWeight={'bold'} color="green">
            Approved
          </Text>
          <Button
            size="xs"
            leftIcon={<FiSend />}
            mt={0.5}
            onClick={() => {
              setSelectedInvoiceRow(props.row.original);
              onOpen();
            }}
          >
            Invoice
          </Button>
        </>
      ) : (
        <Text color="tomato" fontWeight={'bold'}>
          Declined
        </Text>
      ),
  },
  {
    Header: 'Method',
    accessor: 'method',
    disableSortBy: true,
  },
];

export const baseToastProps = {
  duration: 5000,
  isClosable: true,
  position: 'bottom',
  variant: 'top-accent',
};

export const toastTypes = {
  sessionExpired: {
    ...baseToastProps,
    description: 'Your session has expired. Please sign in again to manage billing.',
    status: 'error',
  },
  dataFetchError: {
    ...baseToastProps,
    description:
      'There was an error retreiving your subscriptions and billings.',
    status: 'error',
  },
  noPaymentMethodSelected: {
    ...baseToastProps,
    description:
      'Please select an existing billing method or add new and try again.',
    status: 'error',
  },
  paymentSuccess: {
    ...baseToastProps,
    duration: 10000,
    title: 'Payment Successful!',
    description:
      'Please refresh the page in a few minutes to see the updated status of your services and billing details for this transaction.',
    status: 'success',
  },
  paymentError: {
    ...baseToastProps,
    description: 'Unable to make payment, please try again.',
    status: 'error',
  },
  cardTokenCreationError: {
    ...baseToastProps,
    description: 'Unable to validate card, please try again.',
    status: 'error',
  },
  cardTokenCreationSuccess: {
    ...baseToastProps,
    description: 'Card added successfully!',
    status: 'success',
  },
  paymentMethodUpdateError: {
    ...baseToastProps,
    description: 'Unable to update billing methods, please try again.',
    status: 'error',
  },
  paymentMethodUpdateSuccess: {
    ...baseToastProps,
    description: 'Billing method updated successfully!',
    status: 'success',
  },
  paymentMethodAddSuccess: {
    ...baseToastProps,
    description: 'Billing method added successfully!',
    status: 'success',
  },
  missingCardDetails: {
    ...baseToastProps,
    description: 'Please enter card details and try again.',
    status: 'error',
  },
  failedTransactions: serviceNames => ({
    ...baseToastProps,
    description: `Failed to make payments for ${serviceNames}. Please try again.`,
    status: 'error',
    duration: 10000,
  }),
  allTransactionsFailed: {
    ...baseToastProps,
    description: 'Failed to make payments. Please try again.',
    status: 'error',
  },
  someTransactionsFailed: {
    ...baseToastProps,
    description: 'Failed to make payments for some services. Please try again.',
    status: 'error',
  },
  missingRequiredField: field => ({
    ...baseToastProps,
    description: `${field} is required.`,
    status: 'error',
  }),
};
